import React from "react";

export default function Configurate() {
  return (
    <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_1415_14234)">
        <g clip-path="url(#clip0_1415_14234)">
          <rect x="1" width="40" height="40" rx="12" fill="url(#paint0_linear_1415_14234)" />
          <g clip-path="url(#clip1_1415_14234)" filter="url(#filter1_dd_1415_14234)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.874 11C19.653 10.1405 19.1524 9.37889 18.4511 8.83506C17.7498 8.29124 16.8875 7.99609 16 7.99609C15.1125 7.99609 14.2502 8.29124 13.5489 8.83506C12.8476 9.37889 12.347 10.1405 12.126 11H9V13H12.126C12.347 13.8596 12.8476 14.6212 13.5489 15.165C14.2502 15.7088 15.1125 16.004 16 16.004C16.8875 16.004 17.7498 15.7088 18.4511 15.165C19.1524 14.6212 19.653 13.8596 19.874 13H33V11H19.874ZM26 16C25.113 15.9998 24.2512 16.2944 23.5499 16.8374C22.8486 17.3805 22.3477 18.1412 22.126 19H9V21H22.126C22.347 21.8595 22.8476 22.6211 23.5489 23.165C24.2502 23.7088 25.1125 24.0039 26 24.0039C26.8875 24.0039 27.7498 23.7088 28.4511 23.165C29.1524 22.6211 29.653 21.8595 29.874 21H33V19H29.874C29.6523 18.1412 29.1514 17.3805 28.4501 16.8374C27.7488 16.2944 26.887 15.9998 26 16ZM13.5499 24.8374C14.2512 24.2944 15.113 23.9998 16 24C16.887 23.9998 17.7488 24.2944 18.4501 24.8374C19.1514 25.3805 19.6523 26.1412 19.874 27H33V29H19.874C19.653 29.8595 19.1524 30.6211 18.4511 31.165C17.7498 31.7088 16.8875 32.0039 16 32.0039C15.1125 32.0039 14.2502 31.7088 13.5489 31.165C12.8476 30.6211 12.347 29.8595 12.126 29H9V27H12.126C12.3477 26.1412 12.8486 25.3805 13.5499 24.8374Z" fill="url(#paint1_linear_1415_14234)" />
          </g>
        </g>
      </g>
      <defs>
        <filter id="filter0_di_1415_14234" x="0.5" y="0" width="41" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1415_14234" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1415_14234" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1415_14234" />
        </filter>
        <filter id="filter1_dd_1415_14234" x="-21" y="-18.1015" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1415_14234" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3.89851" />
          <feGaussianBlur stdDeviation="15" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_1415_14234" result="effect2_dropShadow_1415_14234" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1415_14234" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_1415_14234" x1="21" y1="0" x2="21" y2="40" gradientUnits="userSpaceOnUse">
          <stop stop-color="#29282C" />
          <stop offset="1" stop-color="#100F11" />
        </linearGradient>
        <linearGradient id="paint1_linear_1415_14234" x1="8.81456" y1="3.06327" x2="26.2446" y2="28.6031" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0.65" />
        </linearGradient>
        <clipPath id="clip0_1415_14234">
          <rect x="1" width="40" height="40" rx="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_1415_14234">
          <rect width="24" height="24" fill="white" transform="translate(9 8)" />
        </clipPath>
      </defs>
    </svg>
  );
}